import ScrollSlider from './ScrollSlider.component';

export default ScrollSlider;
